<template>
  <MultiSelectPicker
    v-model="value"
    :options="columns"
    id-attribute="name"
    display-attribute="display"
    tooltip="Show/Hide columns"
  >
    <template #button-display>
      <ColumnIcon class="icon-1-5x"></ColumnIcon>
    </template>
  </MultiSelectPicker>
</template>

<script lang="ts" setup>
import ColumnIcon from 'vue-material-design-icons/ViewColumn.vue';
import DataTableColumn from './dataTableColumn';
import MultiSelectPicker from '@/shared/components/MultiSelectPicker.vue';
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';

const props = defineProps({
  columns: {
    type: Array as PropType<DataTableColumn[]>,
    required: true,
  },
  modelValue: {
    type: Array as PropType<DataTableColumn[]>,
    default: [],
  },
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: DataTableColumn[]): void;
}>();
const value = useVModel(props, 'modelValue', emit);
</script>
